var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSandTimerOutlinedBlue(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 5C1 2.79086 2.79086 1 5 1L17 1C19.2091 1 21 2.79086 21 5L21 17C21 19.2091 19.2091 21 17 21L5 21C2.79086 21 1 19.2091 1 17L1 5Z",
    fill: "white",
    stroke: "#3E82FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.78723 14.6143H12.2128M13.4894 16.5H8.51064C8.22862 16.5 8 16.2186 8 15.8714V14.1923C8 14.0581 8.03488 13.9274 8.09955 13.8194L9.56404 11.3729C9.69676 11.1511 9.69676 10.8489 9.56404 10.6271L8.09955 8.18059C8.03488 8.07256 8 7.9419 8 7.80772V6.12857C8 5.78142 8.22862 5.5 8.51064 5.5H13.3617C13.6437 5.5 13.8723 5.78142 13.8723 6.12857V7.81983C13.8723 7.9465 13.8412 8.07023 13.7831 8.17477L12.4176 10.6316C12.2949 10.8522 12.2991 11.1442 12.4279 11.3594L13.9005 13.8194C13.9651 13.9274 14 14.0581 14 14.1923V15.8714C14 16.2186 13.7714 16.5 13.4894 16.5Z",
    stroke: "#3E82FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSandTimerOutlinedBlue);
export default __webpack_public_path__ + "static/media/sand-timer-outlined-blue.cebf9680677e38ea275f62fbdb4de76e.svg";
export { ForwardRef as ReactComponent };